/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust_Gdpr_DescInputs */

const en_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the Privacy Policy for current processing details.`)
};

const de_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten werden in der EU verarbeitet. Aktuelle Anbieter- und Regionsdetails unter /privacy.`)
};

const fr_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données traitées dans l'UE. Pour les détails actuels, voir /privacy.`)
};

const es_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos procesados en la UE. Para detalles actuales, ver /privacy.`)
};

const it_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati elaborati nell'UE. Per i dettagli attuali, vedere /privacy.`)
};

const nl_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens verwerkt in de EU. Voor actuele details, zie /privacy.`)
};

const pl_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane przetwarzane w UE. Aktualne szczegoly: /privacy.`)
};

const fi_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedot kasitelty EU:ssa. Ajantasaiset tiedot: /privacy.`)
};

const da_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data behandlet i EU. For aktuelle oplysninger, se /privacy.`)
};

const sv_landing_trust_gdpr_desc = /** @type {(inputs: Landing_Trust_Gdpr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data behandlad i EU. For aktuell information, se /privacy.`)
};

/**
* | output |
* | --- |
* | "See the Privacy Policy for current processing details." |
*
* @param {Landing_Trust_Gdpr_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_trust_gdpr_desc = /** @type {((inputs?: Landing_Trust_Gdpr_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust_Gdpr_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_trust_gdpr_desc(inputs)
	if (locale === "fr") return fr_landing_trust_gdpr_desc(inputs)
	if (locale === "es") return es_landing_trust_gdpr_desc(inputs)
	if (locale === "it") return it_landing_trust_gdpr_desc(inputs)
	if (locale === "nl") return nl_landing_trust_gdpr_desc(inputs)
	if (locale === "pl") return pl_landing_trust_gdpr_desc(inputs)
	if (locale === "fi") return fi_landing_trust_gdpr_desc(inputs)
	if (locale === "da") return da_landing_trust_gdpr_desc(inputs)
	if (locale === "sv") return sv_landing_trust_gdpr_desc(inputs)
	return en_landing_trust_gdpr_desc(inputs)
});